import { render, staticRenderFns } from "../../../pages/corporation/notic/notic.html?vue&type=template&id=29e173f4&scoped=true&"
import script from "../../../pages/corporation/notic/notic.js?vue&type=script&lang=js&"
export * from "../../../pages/corporation/notic/notic.js?vue&type=script&lang=js&"
import style0 from "../../../pages/corporation/notic/notic.css?vue&type=style&index=0&id=29e173f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e173f4",
  null
  
)

export default component.exports